import axios from "axios";
import {redirectToLogin} from "@/Helper";
axios.defaults.baseURL = process.env.API_URL;

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && (error.response.status === 400 || error.response.status === 401)) {
             redirectToLogin(window.location.href)
        }
        return Promise.reject(error);
    }
);